@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

* {
  box-sizing: border-box;
}

:host {
  max-width: 400px;
}
.outer-wrapper {
  width: 400px;
}

.background-arc {
  stroke: var(--chart-050-hover);
}

.gauge--value {
  flex-direction: column;
  left: -20px;

  .disabled {
    margin-left: 0;
  }
}

.severity-text {
  color: var(--main-titles-inputs-600);
}
